"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Stepper_1 = __importDefault(require("@mui/material/Stepper"));
const Step_1 = __importDefault(require("@mui/material/Step"));
const StepLabel_1 = __importDefault(require("@mui/material/StepLabel"));
const StepContent_1 = __importDefault(require("@mui/material/StepContent"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const Alert_1 = __importDefault(require("@mui/material/Alert"));
const Snackbar_1 = __importDefault(require("@mui/material/Snackbar"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const styles_1 = require("@mui/material/styles");
const x_data_grid_1 = require("@mui/x-data-grid");
const shared_1 = require("../shared");
const Button_1 = __importDefault(require("@mui/material/Button"));
const react_router_dom_2 = require("react-router-dom");
const StyledDataGrid = (0, styles_1.styled)(x_data_grid_1.DataGrid)((theme) => ({
    '& .MuiDataGrid-sortIcon': {
        opacity: 1,
        color: 'white',
    },
    '& .MuiDataGrid-menuIconButton': {
        opacity: 1,
        color: 'white',
    },
    [`& .${x_data_grid_1.gridClasses.row}.even`]: {
        backgroundColor: '#FDFD96',
    },
}));
const CustomStepLabel = (0, styles_1.styled)(StepLabel_1.default)(({ theme }) => ({
    '& .MuiStepLabel-label': {
        fontSize: '1.50vmax',
    },
}));
const CustomnButton = (0, styles_1.styled)(Button_1.default)(({ theme }) => ({
    color: '#FFFF',
    backgroundColor: '#0146C6',
    borderRadius: '1vmax',
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontSize: '1vmax',
    justifyContent: 'center',
    padding: '0.4vmax',
    width: '100%',
    '&:hover': {
        backgroundColor: '#0146C6',
    },
}));
const DesmosPreview = () => {
    const { userId } = (0, react_router_dom_1.useParams)();
    const theme = (0, styles_1.useTheme)();
    const [registerData, setRegisterData] = (0, react_1.useState)(null);
    const [contentApi, setContentApi] = react_1.default.useState(null);
    const [currentData, setCurrentData] = react_1.default.useState([]);
    const [alertOpen, setAlertOpen] = react_1.default.useState(false);
    const [activeStep, setActiveStep] = react_1.default.useState(0);
    const [open, setOpen] = react_1.default.useState(true);
    const navigate = (0, react_router_dom_2.useNavigate)();
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    (0, react_1.useEffect)(() => {
        initData();
    }, []);
    const compare = (a, b) => {
        if ((a === null || a === void 0 ? void 0 : a.TestName) === (b === null || b === void 0 ? void 0 : b.TestName)) {
            if ((a === null || a === void 0 ? void 0 : a.Module) === (b === null || b === void 0 ? void 0 : b.Module)) {
                const questionNoA = !isNaN(a === null || a === void 0 ? void 0 : a.QuestionNo) ? parseInt(a === null || a === void 0 ? void 0 : a.QuestionNo) : a === null || a === void 0 ? void 0 : a.QuestionNo;
                const questionNoB = !isNaN(b === null || b === void 0 ? void 0 : b.QuestionNo) ? parseInt(b === null || b === void 0 ? void 0 : b.QuestionNo) : b === null || b === void 0 ? void 0 : b.QuestionNo;
                return questionNoA - questionNoB;
            }
            else {
                return a === null || a === void 0 ? void 0 : a.Module.localeCompare(b === null || b === void 0 ? void 0 : b.Module);
            }
        }
        else {
            return a === null || a === void 0 ? void 0 : a.TestName.localeCompare(b === null || b === void 0 ? void 0 : b.TestName);
        }
    };
    const initData = async () => {
        try {
            const regData = await (0, shared_1.getUserData)();
            setRegisterData(regData || null);
            const subData = await (0, shared_1.getDesmosSubscribed)(userId);
            if (subData === null || subData === void 0 ? void 0 : subData.isSubscribed) {
                navigate(`/desmos-main/${userId}`);
            }
            const desmos = await (0, shared_1.getStrapiData)(`desmos-spreadsheets?&pagination[pageSize]=8`);
            const attributesArray = desmos === null || desmos === void 0 ? void 0 : desmos.map((item) => {
                return Object.assign(Object.assign({}, item === null || item === void 0 ? void 0 : item.attributes), { id: item.id });
            });
            const sortedData = attributesArray.sort(compare);
            const distinctTestNames = [...new Set(sortedData === null || sortedData === void 0 ? void 0 : sortedData.map((item) => item === null || item === void 0 ? void 0 : item.TestName))];
            if (distinctTestNames.length > 0) {
                distinctTestNames.unshift('All');
            }
            setCurrentData(sortedData || []);
            setContentApi(await (0, shared_1.getCmsURL)());
        }
        catch (error) {
            console.error('Error fetching user data', error);
        }
    };
    const preventCopyPaste = (e) => {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        handleSnackBarOpen();
    };
    const handleSnackBarOpen = () => {
        setAlertOpen(true);
    };
    const handleSnackBarClose = () => {
        setAlertOpen(false);
    };
    const handleLinkClick = (url) => {
        navigate(url);
    };
    const renderImage = (data) => {
        const imageRegex = /!\[([^\]]*?)\]\(([^)]*?)\)/g;
        const newData = data === null || data === void 0 ? void 0 : data.replace(imageRegex, (match, altText, imageUrl) => {
            return `<img style='height: 90%; width: 90%;' alt='${altText}' src='${contentApi}${imageUrl}' />`;
        });
        return newData;
    };
    const columns = [
        { field: 'TestName', headerName: 'Name', minWidth: 100, flex: 1, headerAlign: 'center', align: 'center' },
        { field: 'Module', headerName: 'Module', minWidth: 100, flex: 1, headerAlign: 'center', align: 'center' },
        { field: 'QuestionNo', headerName: 'Question #', minWidth: 100, flex: 1, headerAlign: 'center', align: 'center' },
        { field: 'DifficultyLevel', headerName: 'Difficulty', minWidth: 100, flex: 1, headerAlign: 'center', align: 'center' },
        {
            field: 'LinkToModule',
            headerName: 'Link To Module',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                var _a, _b;
                return ((0, jsx_runtime_1.jsx)("a", Object.assign({ href: (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.LinkToModule, target: '_blank', style: { pointerEvents: 'none' } }, { children: (_b = params === null || params === void 0 ? void 0 : params.row) === null || _b === void 0 ? void 0 : _b.LinkToModuleName })));
            },
        },
        { field: 'CollegeBoardCategory', headerName: 'College Board Category', minWidth: 100, flex: 1, headerAlign: 'center', align: 'left' },
        { field: 'DesmosCategory', headerName: 'Desmos Category', minWidth: 100, flex: 1, headerAlign: 'center', align: 'left' },
        {
            field: 'DesmosLink',
            headerName: 'Desmos Link',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params) => {
                var _a, _b;
                return ((0, jsx_runtime_1.jsx)("a", Object.assign({ href: (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.DesmosLink, target: '_blank', style: { pointerEvents: 'none' } }, { children: (_b = params === null || params === void 0 ? void 0 : params.row) === null || _b === void 0 ? void 0 : _b.DesmosLink })));
            },
        },
        {
            field: 'AdvancedDesmosLink',
            headerName: 'Advanced Desmos Link',
            minWidth: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params) => {
                var _a, _b;
                return ((0, jsx_runtime_1.jsx)("a", Object.assign({ href: (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.AdvancedDesmosLink, target: '_blank', style: { pointerEvents: 'none' } }, { children: (_b = params === null || params === void 0 ? void 0 : params.row) === null || _b === void 0 ? void 0 : _b.AdvancedDesmosLink })));
            },
        },
    ];
    const steps = [
        {
            label: 'Step 1',
            description: `Filter, sort, and display questions to practice`,
        },
        {
            label: 'Step 2',
            description: 'View step-by-step solutions that we created for you in interactive Desmos links',
        },
        {
            label: 'Step 3',
            description: `Practice and repeat with as many College Board Bluebook questions as you’d like. You can sort questions by College Board category or our proprietary Desmos categories on your road to Total World Domination!`,
        },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'home-page-root', onCopy: (e) => preventCopyPaste(e), onPaste: (e) => preventCopyPaste(e), onCut: (e) => preventCopyPaste(e) }, { children: [(0, jsx_runtime_1.jsx)("img", { src: '/assets/background_6.png', alt: 'home-screen', className: 'bg_1_image', loading: 'lazy' }), (0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: { width: '100%', zIndex: 1 } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ className: 'college_link_header' }, { children: "Desmos Question By Question Preview" })), (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'column', spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(Stack_1.default, Object.assign({ direction: 'row', justifyContent: 'space-between', alignItems: 'center' }, { children: activeStep >= 0 ? ((0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'row', spacing: 2, alignItems: 'center' }, { children: [(0, jsx_runtime_1.jsx)("iframe", { className: 'desmos_preview_video', src: 'https://www.youtube.com/embed/DdBNr_getig', title: 'Desmos offering', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share', sandbox: 'allow-same-origin allow-forms allow-popups allow-scripts allow-presentation', allowFullScreen: true }), (0, jsx_runtime_1.jsxs)(Typography_1.default, Object.assign({ className: 'desmos_preview_header' }, { children: [(0, jsx_runtime_1.jsx)("a", Object.assign({ href: 'https://www.youtube.com/embed/DdBNr_getig', target: '_blank' }, { children: "Watch" })), ' ', "Josh explain our question-by-question Desmos tool;"] }))] }))) : ((0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'row', spacing: 1, alignItems: 'center' }, { children: [(0, jsx_runtime_1.jsx)("img", { src: '/assets/tutor.png', alt: 'tutor', className: 'desmos_preview_image_small', loading: 'lazy' }), (0, jsx_runtime_1.jsxs)(Typography_1.default, Object.assign({ className: 'desmos_preview_header_small' }, { children: [(0, jsx_runtime_1.jsx)("a", Object.assign({ href: 'https://www.youtube.com/embed/DdBNr_getig', target: '_blank' }, { children: "Watch" })), ' ', "Josh explain our question-by-question Desmos offering"] }))] }))) })), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, sx: { width: '100%' }, direction: 'row' }, { children: [(0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, xs: 3 }, { children: [(0, jsx_runtime_1.jsx)(Stepper_1.default, Object.assign({ activeStep: activeStep, orientation: 'vertical', sx: { padding: '0 10%', marginTop: 0 } }, { children: steps.map((step, index) => ((0, jsx_runtime_1.jsxs)(Step_1.default, { children: [(0, jsx_runtime_1.jsx)(CustomStepLabel, { children: step.label }), (0, jsx_runtime_1.jsxs)(StepContent_1.default, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ className: 'desmos_preview_sub_header' }, { children: step.description })), (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { mb: 2 } }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: 'contained', disabled: index === steps.length - 1, onClick: handleNext, sx: { mt: 1, mr: 1 } }, { children: "Continue" })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ disabled: index === 0, onClick: handleBack, sx: { mt: 1, mr: 1, color: '#000' } }, { children: "Back" }))] }) }))] })] }, step.label))) })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: 'contained', onClick: () => handleLinkClick(`/subscriptions/${userId}`), sx: { mt: 1, mr: 1 } }, { children: "Subscribe Now" }))] })), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ item: true, xs: true, style: { maxWidth: '75%' } }, { children: [activeStep === 0 && ((0, jsx_runtime_1.jsx)(Stack_1.default, { children: (0, jsx_runtime_1.jsx)("img", { src: '/assets/desmos_question1.png', alt: 'khan_question', className: 'desmos_preview_image_1', loading: 'lazy' }) })), activeStep === 1 && ((0, jsx_runtime_1.jsx)(Stack_1.default, { children: (0, jsx_runtime_1.jsx)("img", { src: '/assets/khan_question.png', alt: 'khan_question', className: 'desmos_preview_image_2', loading: 'lazy' }) })), activeStep === 2 && ((0, jsx_runtime_1.jsx)(Stack_1.default, { children: (0, jsx_runtime_1.jsx)("img", { src: '/assets/desmos_question.png', alt: 'desmos_question', className: 'desmos_preview_image_3', loading: 'lazy' }) }))] }))] }))] })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ className: 'site_licensing' }, { children: "Site licensing is available for schools and tutoring organizations. To learn more, please contact us at +1 (888) 842-5742." }))] })), (0, jsx_runtime_1.jsx)(Snackbar_1.default, Object.assign({ autoHideDuration: 6000, onClose: handleSnackBarClose, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, open: alertOpen }, { children: (0, jsx_runtime_1.jsx)(Alert_1.default, Object.assign({ onClose: handleSnackBarClose, severity: 'warning', variant: 'filled', sx: { width: '100%' } }, { children: "Copying and pasting is not allowed!" })) }))] })));
};
exports.default = DesmosPreview;
